import { Box, Typography } from "@material-ui/core";
import { useState, useEffect } from "react";
import useStyles from '../../../assets/styles/styles';
import {useSelector } from "react-redux";



const DetailAnthropometry = () => {
    const classes = useStyles();
    const modelAnthropometryReducer = useSelector(state => state.appointmentsReducer);
    const modelAnthropometry = modelAnthropometryReducer?.anthropometry;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 760);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 760);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const laboratoryDate = modelAnthropometry?.[0]?.fechaFormateada
        ? new Date(modelAnthropometry[0].fechaFormateada).toLocaleDateString('es-ES')
        : "";

    const fields = [
        {
            label: "Peso",
            value: modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Peso")
                ? `${modelAnthropometry[0].resultados.find(item => item.nombre === "Peso").valor} ${modelAnthropometry[0].resultados.find(item => item.nombre === "Peso").unidad}`
                : null,
            condition: !!modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Peso")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Talla",
            value: modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Talla")
                ? `${modelAnthropometry[0].resultados.find(item => item.nombre === "Talla").valor} ${modelAnthropometry[0].resultados.find(item => item.nombre === "Talla").unidad}`
                : null,
            condition: !!modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Talla")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Perimetro Cefalico",
            value: modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Perimetro Cefalico")
                ? `${modelAnthropometry[0].resultados.find(item => item.nombre === "Perimetro Cefalico").valor} ${modelAnthropometry[0].resultados.find(item => item.nombre === "Perimetro Cefalico").unidad}`
                : null,
            condition: !!modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Perimetro Cefalico")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Perimetro Toráxico",
            value: modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Perimetro Toráxico")
                ? `${modelAnthropometry[0].resultados.find(item => item.nombre === "Perimetro Toráxico").valor} ${modelAnthropometry[0].resultados.find(item => item.nombre === "Perimetro Toráxico").unidad}`
                : null,
            condition: !!modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Perimetro Toráxico")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Perimetro Branquial",
            value: modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Perimetro Branquial")
                ? `${modelAnthropometry[0].resultados.find(item => item.nombre === "Perimetro Branquial").valor} ${modelAnthropometry[0].resultados.find(item => item.nombre === "Perimetro Branquial").unidad}`
                : null,
            condition: !!modelAnthropometry?.[0]?.resultados?.find(item => item.nombre === "Perimetro Branquial")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
    ];

    const splitText = (text, wordLimit) => {
        if (typeof text !== 'string') return [];
        const descriptionEvolution = text.split(' ');
        const result = [];
        let currentLine = [];
        descriptionEvolution.forEach((word) => {
            currentLine.push(word);
            if (currentLine.length >= wordLimit) {
                result.push(currentLine.join(' '));
                currentLine = [];
            }
        });

        if (currentLine.length > 0) {
            result.push(currentLine.join(' '));
        }
        return result;
    };

    return (
        <>
            <Box className={`${classes.boxContent}`}>
                <>
                    <Box style={{ marginBottom: '10px' }}>
                        <Typography className={`${classes.txtCardDescription} ${classes.titleDetailLaboratory}`}>
                            ANTROPOMETRIA {laboratoryDate && `| ${laboratoryDate}`}
                        </Typography>
                    </Box>

                    {fields.map((field, index) => (
                        field.condition && (
                            <Box key={index} style={{ marginBottom: "10px" }}>
                                <Typography className={field.labelClass}>{field.label}</Typography>
                                {isMobile
                                    ? splitText(field.value, 6).map((line, lineIndex) => (
                                        <Typography key={lineIndex} className={field.valueStyle}>{line}</Typography>
                                    ))
                                    : <Typography className={field.valueStyle}>{field.value}</Typography>
                                }
                               
                            </Box>
                        )
                    ))}
                </>
            </Box>
        </>
    );
};

export default DetailAnthropometry;
